import type { FaireProductEntity } from "../../entity_types/product";

export const p_b3c8heysmt: FaireProductEntity = {
  token: "p_b3c8heysmt",
  type: "product",
  name: "USA Stars & Bow Patch Women's Short Sleeve T-Shirt - White",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/c70ef13dd450423ed6c65bdcbbc827d095245ceb8c43761cbe2341f0fbedc6ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4fd9de37712a33ee078c1faff760a11f4ce71dde41ca6cde287d607a761cff24.jpeg",
    "https://cdn.faire.com/fastly/d93fc0100b457ad9f5a7b7d26e7b66ec35c9fa621878a2104b4daf316bfb7ff9.jpeg",
    "https://cdn.faire.com/fastly/081fdc85b3b64355730280be03e73c84c9d7f1d149fdea88c1a1eed24d67b986.jpeg",
  ],
  priceDollars: 19,
  description:
    "Celebrate in style with this sparkling white top that pairs a bold, glittery design with a shimmering red bow for a look that’s as festive as a fireworks display.\n\nFeatures:\n * Shirt Color: White \n * Graphic Color: Red, white and blue sequins \n * Material: 100% Cotton \n * Features: Tagless inside neck label for an itch-free wear \n * Fit: Adult Unisex \n * Care: Machine washable, tumble dry low \n\nEach t-shirt is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:28.254Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
